/* eslint-disable react/prop-types */
import React from 'react';
import get from 'lodash.get';
import { style } from './style.less';
import backend from './backend';


const QiYuLink = '/st/platform/qiyu?scope=musickf&biz=musician_Web_lower_right_corner';
const BeeLink = '/#/msg/m/private_detail?id=48132&nickname=%E9%9F%B3%E4%B9%90%E4%BA%BA%E5%B0%8F%E8%9C%9C%E8%9C%82&count=0&noticeaccountflag=false';

const MusicianNode = () => {
    function handleClick() {
        let link = QiYuLink;
        return backend.getArtistContract().then((res) => {
            const signType = get(res, 'data.signType', false);
            link = signType ? BeeLink : QiYuLink;
            window.open(link);
        }).catch(() => {
            window.open(link);
        });
    }
    return <a onClick={handleClick}>音乐人相关</a>;
};

const QiYuContent = ({ isOpen, messageCount = 0 }) => {
    if (isOpen) {
        return (
            <div className={`m-qiyu-ctn ${style}`}>
                <MusicianNode />
                {messageCount > 0 ? <div className="dot" /> : null}
            </div>
        );
    }
    return <MusicianNode />;
};

export default QiYuContent;



// WEBPACK FOOTER //
// ./client/component/qiyucontent/index.js